import i18n from 'i18next';
import LngDetector from 'i18next-browser-languagedetector';
import Resources from './resources';

i18n.use(LngDetector).init({
  debug: false,
  // Have a common namespace used around the full app
  defaultNS: 'translations',
  detection: {
    lookupCookie: 'i18next',
    lookupFromPathIndex: 0,
    lookupLocalStorage: 'i18nextLng',
    order: ['path', 'querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag', 'subdomain']
  },
  fallbackLng: 'en',
  interpolation: {
    // Not needed for react!!
    escapeValue: false,
    formatSeparator: ','
  },
  // We use content as keys
  keySeparator: false,
  ns: ['translations'],
  preload: ['de', 'en'],
  react: { useSuspense: false },
  // We init with resources
  resources: Resources
});

export { i18n };
